<template>
  <b-card
      class="m-0"
      style="font-size: small"
      bg-variant="light"
      header-bg-variant="dark"
      header-text-variant="white"
      align="center"
  >
    <template v-slot:header>
      <div style="display: flex; align-items: flex-start;">
        <div class="metric-color-tile" :style="'background:' + metricItem.color + ''"/>
        <div>{{metricItem.label}}</div>
        <div v-if="metricItem.hasSubLabel" class="metric-sub-label">[ {{metricItem.subLabel}} ]</div>
        <!--
       <b-button
           style="position: absolute; top:0px; right:-6px;"
           class="text-right mx-2 px-1 py-0" aria-label="Close" variant="dark" size="sm">
         <font-awesome-icon icon="times-circle"/>
       </b-button>
       -->
     </div>
   </template>
   <b-card-text >
     <Transition mode="out-in" name="fade-in">
       <div v-if="sessionInProgress" class="h5" :key="metricItem.type">{{metricItem.last}}</div>
     </transition>
     <div>Average: {{metricItem.average}}</div>
     <div>Max: {{metricItem.max}}</div>
     <div>Min: {{metricItem.min}}</div>
   </b-card-text>
 </b-card>
</template>

<script>
import {mapGetters} from "vuex";

export default {
 name: "MeasurementMetricTile",
 props: ['metricData'],
 data() {
   return {

   }
 },
 created () {

 },
 computed: {
   ...mapGetters({

     session: 'session/current',
     sessionLoading: 'session/currentLoadingOrNull',
   }),
   sessionInProgress() {
     return !this.sessionLoading && this.session && this.session.isComplete == false;
   },

   metricItem: function () {
     return this.metricData;
   }
 }
}
</script>

<style scoped>
.fade-in-enter-active {
 transition: opacity 300ms cubic-bezier(0.55, 0.085, 0.68, 0.53);
}

.fade-in-leave-active {
 transition: opacity 225ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.fade-in-enter,
.fade-in-leave-to {
 opacity: 0;
}

.metric-color-tile {
 width: 16px; height: 16px;
 border: 1px solid #17191B;
 vertical-align: middle;
 margin: 2px 6px;
}

.metric-sub-label {
  margin: 2px 6px;
  font-size: x-small;
  vertical-align: middle;
}
</style>